import { useState, useEffect } from 'react';
import { getInstallState, onInstallChange, canPromptInstall, promptInstall } from '../services/installApp';

// Flujo UNIFICADO de instalación para el botón del login, el de Ajustes y el
// banner: si el navegador puede instalar la PWA por su cuenta (Chromium —
// Chrome/Edge/Samsung — en Android y escritorio) lanza el diálogo NATIVO; si no
// (iOS Safari, Firefox…) abre el modal de instrucciones. `hidden` es true cuando
// la app ya corre instalada, para ocultar el botón.
export function useInstallFlow() {
  const [state, setState] = useState(getInstallState());
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => onInstallChange(setState), []);

  const hidden = state.standalone || state.installed;

  const trigger = async () => {
    if (canPromptInstall()) {
      await promptInstall();
    } else {
      setModalOpen(true);
    }
  };

  return {
    hidden,
    trigger,
    modalOpen,
    closeModal: () => setModalOpen(false),
    canPrompt: state.canPromptInstall,
  };
}
